var React = require('react');

function Envelope (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.25,6.6V24.885h24V6.6Zm21.429,4.115L14.25,17,4.821,10.714V8.428l9.429,6.286,9.429-6.286Z","transform":"translate(-2.25 -3.602)","key":0}),React.createElement("rect",{"fill":"none","width":"24","height":"24","key":1})]);
}

Envelope.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Envelope;

Envelope.default = Envelope;
